import { Account } from '@/features/accounts/types';
import AccountCard from './AccountCard';
import AddAccountCard from './AccountCard/AddAccountCard';

interface Props {
  accounts: Account[];
  onActivated: () => void;
  onCreate: () => void;
}

export default function ListView({ accounts, onActivated, onCreate }: Props) {
  return (
    <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
      {accounts.map((account) => (
        <AccountCard
          key={account.id}
          account={account}
          onActivated={onActivated}
        />
      ))}
      <AddAccountCard onClick={onCreate} />
    </div>
  );
}
